document.addEventListener('DOMContentLoaded', function() {
    rating_stars_fill();
    variant_changer();
    gallery_add_to_basket();
    main_add_to_basket();
    wme_care_overlay();
    updateCountdown();
    specifications_scrollspy();
    specifications_sidebar();
    setInterval(updateCountdown, 60000); // Update countdown every minute
});

function updateCountdown() {
    const deliveryDetails = document.getElementById("fast_delivery_details");

    if (deliveryDetails) {
        let now = new Date();
        let cutoffHour = 15; // 3 PM
        let deliveryDays = parseInt(deliveryDetails.dataset.fastDeliveryDays, 10);

        // Get today's date at UTC midnight
        let deliveryDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));

        // Determine if order is placed before or after cutoff time
        if (now.getHours() < cutoffHour) {
            deliveryDate = getNextBusinessDay(deliveryDate, deliveryDays);
        } else {
            // If cutoff has passed, start from the next business day
            deliveryDate = getNextBusinessDay(deliveryDate, deliveryDays + 1);
        }

        // Format and display delivery date
        let options = { weekday: 'long', day: 'numeric', month: 'long' };
        document.getElementById("summary-delivery-date").textContent = deliveryDate.toLocaleDateString("en-US", options);

        // Calculate time remaining until next business day's cutoff at 3 PM
        let cutoffTime = new Date();
        if (now.getHours() >= cutoffHour) {
            cutoffTime = getNextBusinessDay(cutoffTime, 1); // Move to next business day
        }
        cutoffTime.setHours(cutoffHour, 0, 0, 0);

        let timeRemaining = cutoffTime - now;

        if (timeRemaining > 0) {
            let hours = Math.floor(timeRemaining / (1000 * 60 * 60));
            let minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
            document.getElementById("summary-delivery-countdown").textContent = `${hours} hrs ${minutes} mins`;
        } else {
            document.getElementById("summary-delivery-countdown").textContent = "Updating...";
            setTimeout(updateCountdown, 1000); // Retry if something went wrong
        }
    }
}

// Function to get the next business day after a certain number of days
function getNextBusinessDay(date, daysToAdd) {
    let result = new Date(date.getTime()); // clone the date
    let originalDay = result.getUTCDay();

    // Special case: If today is Friday after cutoff, Saturday, or Sunday, skip to Tuesday
    if (
        (originalDay === 5 && daysToAdd === 1) || // Friday
        originalDay === 6 || // Saturday
        originalDay === 0    // Sunday
    ) {
        // Move to upcoming Tuesday
        do {
            result.setUTCDate(result.getUTCDate() + 1);
        } while (result.getUTCDay() !== 2); // 2 = Tuesday

        return result;
    }

    // Standard business day addition logic
    let businessDaysAdded = 0;
    while (businessDaysAdded < daysToAdd) {
        result.setUTCDate(result.getUTCDate() + 1);
        let dayOfWeek = result.getUTCDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
            businessDaysAdded++;
        }
    }

    return result;
}


function wme_care_overlay() {
    const overlay = document.getElementById("wme-care-overlay");

    if(!overlay || overlay.getAttribute("data-warranty-exists") === "false"){
        return;
    }


    const checkbox = document.getElementById("wme-care-add-on-checkbox");
    const closeButton = document.getElementById("care-overlay-close-button");
    const addPlanButton = document.getElementById("add-plan-button");
    const variantDropdown = document.getElementById("variant-main-dropdown");
    checkbox.checked = false;

    function modalOpen() {
        overlay.classList.remove("wme-care-hide");
        document.body.classList.add("modal-open");
    }

    function modalClose() {
        overlay.classList.add("wme-care-hide");
        document.body.classList.remove("modal-open");
    }

    checkbox.addEventListener("click", function(event) {
        if (this.checked) {
            modalOpen();
        }
        this.checked = false;
        const selectedWarranty = document.querySelector('input[name="warranty_plan"]:checked');
        if (selectedWarranty){
            const baseVariantId = selectedWarranty.closest(".option-item").getAttribute("data-base-variant-id");
            if (variantDropdown) {
                variantDropdown.setAttribute("data-variant_id", baseVariantId);
            }

        }
    });

    overlay.addEventListener("click", function(event) {
        if (event.target === overlay){
            modalClose();
        }
    });

    addPlanButton.addEventListener("click", async() => {
        const selectedWarranty = document.querySelector('input[name="warranty_plan"]:checked');
        if (selectedWarranty){
            const warrantyVariantId = selectedWarranty.closest(".option-item").getAttribute("data-warranty-variant-id");

            if (variantDropdown) {
                variantDropdown.setAttribute("data-variant_id", warrantyVariantId);
                checkbox.checked = true;
        
                try {
                    addPlanButton.disabled = true;
                    addPlanButton.textContent = "Adding...";
                    const checkboxes = document.querySelectorAll('[data-multi-add]:checked');
                    const additionalProducts = Array.from(checkboxes).map(checkbox => ({
                        id: checkbox.dataset.id,
                        quantity: 1
                    }));

                    const mainProduct = {
                        id: variantDropdown.dataset.variant_id,
                        quantity: variantDropdown.value
                    };

                    const allProducts = [mainProduct, ...additionalProducts];
                    const response = await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({items: allProducts})
                    }).then(() => {
                        addPlanButton.disabled = false;
                        addPlanButton.textContent = 'Add to Basket';
                        modalClose();
                        window.location.href = '/cart';
                    })
                    window.location.href = '/cart';
        
                } catch (error){
                    console.error("Error adding the items to the Basket.");
                    addToCartButton.disabled = false;
                    addToCartButton.textContent = 'Add to Basket';
                } 
            }
        }
    });

    closeButton.addEventListener("click", function() {
        modalClose();
    });
}


function gallery_add_to_basket(){
    const addToCartButton = document.getElementById("gallery-add-to-cart-btn");
    const checkboxes = document.querySelectorAll('.gallery-quick-add');
    const totalPriceElement = document.getElementById('gallery-quick-add-total');

    if (!checkboxes || checkboxes.length === 0 || !totalPriceElement){
        return;
    }



    const updateTotalPrice = () => {
        let totalPrice = 0;

        checkboxes.forEach((checkbox) => {
            if (checkbox.checked){
                const price = parseFloat(checkbox.getAttribute("data-price")) || 0;
                totalPrice += price;
            }
        });

        totalPriceElement.textContent = formatPrice(totalPrice);
    };

    const formatPrice = (price) => {
        return new Intl.NumberFormat("en-GB", {
            style: "currency",
            currency: "GBP",
        }).format(price / 100);
    };

    checkboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", updateTotalPrice);
    });

    updateTotalPrice();

    const addToCart = async() => {
        const selectedVariantIds = Array.from(checkboxes)
        .filter((checkbox) => checkbox.checked)
        .map((checkbox) => checkbox.getAttribute('data-id'));

        if (selectedVariantIds.length == 0){
            return;
        }

        console.log(selectedVariantIds)

        const itemsToAdd = selectedVariantIds.map((variantId) => ({
            id: variantId,
            quantity: 1
        }));

        try {
            addToCartButton.disabled = true;
            addToCartButton.textContent = "Adding...";

            const response = await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ items: itemsToAdd}),
            });
            if (!response.ok){
                throw new Error('Failed to add items to cart.');
            }

            window.location.href = '/cart';
        } catch (error) {
            console.error("Error adding the items to the Basket.")
        } finally {
            addToCartButton.disabled = false;
            addToCartButton.textContent = 'Add to Basket'
        }
    };

    addToCartButton.addEventListener("click", addToCart);
}


function main_add_to_basket(){
    const addToCartButton = document.querySelector('#product-add-to-basket');
    const mobileAddToCartButton = document.querySelector('#product-mobile-add-to-basket');

    if (!addToCartButton) return;

    addToCartButton.addEventListener('click', async() =>  {
        try{
            addToCartButton.disabled = true;
            addToCartButton.textContent = 'Adding...';

            const variantDropdown = document.getElementById('variant-main-dropdown');
            const checkboxes = document.querySelectorAll('[data-multi-add]:checked');
            const additionalProducts = Array.from(checkboxes).map(checkbox => ({
                id: checkbox.dataset.id,
                quantity: 1
            }));

            const mainProduct = {
                id: variantDropdown.dataset.variant_id,
                quantity: variantDropdown.value
            };

            const allProducts = [mainProduct, ...additionalProducts];
            
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({items: allProducts})
            }).then(() => {
                window.location.href = '/cart';
                addToCartButton.disabled = false;
                addToCartButton.textContent = 'Add to Basket';
            })
            window.location.href = '/cart';

        } catch (error){
            console.error("Error adding the items to the Basket.");
            addToCartButton.disabled = false;
            addToCartButton.textContent = 'Add to Basket';
        } 
    });

    mobileAddToCartButton.addEventListener('click', async() =>  {
        try{
            mobileAddToCartButton.disabled = true;
            mobileAddToCartButton.textContent = 'Adding...';

            const variantDropdown = document.getElementById('variant-main-dropdown');
            const checkboxes = document.querySelectorAll('[data-multi-add]:checked');
            const additionalProducts = Array.from(checkboxes).map(checkbox => ({
                id: checkbox.dataset.id,
                quantity: 1
            }));

            const mainProduct = {
                id: variantDropdown.dataset.variant_id,
                quantity: variantDropdown.value
            };

            const allProducts = [mainProduct, ...additionalProducts];
            
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({items: allProducts})
            }).then(() => {
                window.location.href = '/cart';
                mobileAddToCartButton.disabled = false;
                mobileAddToCartButton.textContent = 'Add to Basket';
            })
            window.location.href = '/cart';

        } catch (error){
            console.error("Error adding the items to the Basket.");
            mobileAddToCartButton.disabled = false;
            mobileAddToCartButton.textContent = 'Add to Basket';
        } 
    });
}

function specifications_scrollspy() {
    const container = document.getElementById("spec-content-desktop");
    const sections = container.querySelectorAll("section");
    const navLinks = document.querySelectorAll(".specifications-sidebar .nav-link");
  
    function updateActiveLink() {
      const scrollTop = container.scrollTop + 80;
  
      let currentSectionId = null;
  
      sections.forEach((section) => {
        const sectionTop = section.offsetTop - container.offsetTop;
        const sectionHeight = section.offsetHeight;
  
        if (scrollTop >= sectionTop - 10 && scrollTop < sectionTop + sectionHeight - 10) {
          currentSectionId = section.id;
        }
      });
  
      navLinks.forEach((link) => {
        const targetId = link.getAttribute("data-target");
        link.classList.toggle("active", targetId === currentSectionId);
      });
    }
  
    container.addEventListener("scroll", updateActiveLink);
    updateActiveLink(); // run once on load
  }
  
function specifications_sidebar(){
    document.querySelectorAll('.specifications-sidebar .nav-link').forEach(link => {
        link.addEventListener('click', function () {
          const targetId = this.getAttribute('data-target');
          const targetEl = document.getElementById(targetId);
          const container = document.getElementById('spec-content-desktop');
    
          if (targetEl && container) {
            container.scrollTo({
              top: targetEl.offsetTop,
              behavior: 'smooth'
            });
          }
        });
      });
}

function variant_changer(){
    const swatchItems = document.querySelectorAll(".swatch-item");
    const quantityDropdown = document.getElementById("variant-main-dropdown");
    const wmeCareCheckbox = document.getElementById("wme-care-add-on-checkbox");
    const warrantyOptions = document.querySelectorAll(".option-item");
    const warrantyRadios = document.querySelectorAll('input[name="warranty_plan"]');

    const formatPrice = (priceInPence) => {
        return new Intl.NumberFormat("en-GB", {
            style: "currency",
            currency: "GBP",
        }).format(priceInPence / 100);
    };

    const updateQuantityDropdown = (maxQuantity) => {
        quantityDropdown.innerHTML = "";
        let limit = 50
        if (maxQuantity > 0 && maxQuantity < 50){
            limit = maxQuantity;
        } 

        for (let i = 1; i <= limit; i++) {
            const option = document.createElement("option");
            option.value = i;
            option.textContent = i;

            if (i === 1){
                option.selected = true;
            }
            quantityDropdown.appendChild(option);
        }
    }



    const handleVariantSelection = (selectedSwatch) => {
        const variantQuantity = parseInt(selectedSwatch.getAttribute("data-variant-quantity"), 10);
        const variantId = selectedSwatch.getAttribute("data-variant-id");
        const variantPrice = parseInt(selectedSwatch.getAttribute("data-price"), 10) || 0;
        const variantCompareAtPrice = parseInt(selectedSwatch.getAttribute("data-compare-at-price"), 10) || 0;
        const priceContainer = document.getElementById("main-price-container")
        const summaryPriceContainer = document.getElementById("summary-top-container");
        const priceContainers = [priceContainer, summaryPriceContainer].filter(Boolean);
        const previousPriceElements = document.querySelectorAll(".product-page-previous-price");
        const savingAmountElements = document.querySelectorAll(".product-page-saving-amount");
        const mobileStickyPriceElements = document.querySelectorAll(".mobile-sticky-price__value");
        const mobileStickyCompareAtElements = document.querySelectorAll(".mobile-sticky-price__compare-at");
        const proPlanValueElements = document.querySelectorAll(".product-page-pro-plan__value");
        const isOnSale = variantCompareAtPrice > variantPrice;
        const savingAmount = ((variantCompareAtPrice - variantPrice) / 100).toFixed(2);


        const trade_summary_section = document.getElementById('summary-trade-section')
  
        if (trade_summary_section){
            
            const trade_discount = trade_summary_section.getAttribute("data-discount-rate");
            const trade_price = variantPrice * (1 - trade_discount);

            const trade_pounds = (parseInt(trade_price, 10) / 100).toFixed(2);
            const [trade_whole_part, trade_decimal_part] = trade_pounds.split(".");
            
            trade_summary_section.querySelector(".product-price-whole-super").textContent = trade_whole_part;
            trade_summary_section.querySelector(".product-price-decimal-super").textContent = trade_decimal_part;
        
            const trade_main_section = document.getElementById('trade-discount-section-main');


            trade_main_section.querySelector(".product-price-whole-super").textContent = trade_whole_part;
            trade_main_section.querySelector(".product-price-decimal-super").textContent = trade_decimal_part;
        
        }

        updateQuantityDropdown(variantQuantity);
        quantityDropdown.setAttribute("data-variant_id", variantId);

        const pounds = (variantPrice / 100).toFixed(2);
        const [wholePart, decimalPart] = pounds.split(".");

        priceContainers.forEach((container) => {
            const wholeElement = container.querySelector(".product-price-whole-super");
            const decimalElement = container.querySelector(".product-price-decimal-super");

            if (wholeElement && decimalElement) {
                wholeElement.textContent = wholePart;
                decimalElement.textContent = decimalPart;
            }
        });

        previousPriceElements.forEach((element) => {
            if (isOnSale) {
                const formattedCompareAt = (variantCompareAtPrice / 100).toFixed(2);
                element.textContent = `RRP: £${formattedCompareAt}`;
                element.style.display = "";
            } else {
                element.textContent = "";
                element.style.display = "none";
            }
        });

        savingAmountElements.forEach((element) => {
            if (isOnSale) {
                element.textContent = `Save £${savingAmount}`;
                element.style.display = "inline-flex";
            } else {
                element.textContent = "";
                element.style.display = "none";
            }
        });

        mobileStickyPriceElements.forEach((element) => {
            element.textContent = formatPrice(variantPrice);
        });

        mobileStickyCompareAtElements.forEach((element) => {
            if (isOnSale) {
                element.textContent = formatPrice(variantCompareAtPrice);
                element.style.display = "inline-flex";
            } else {
                element.textContent = "";
                element.style.display = "none";
            }
        });

        const proPlanPrice = Math.round(variantPrice * 0.88);
        proPlanValueElements.forEach((element) => {
            element.textContent = formatPrice(proPlanPrice);
        });

        swatchItems.forEach((swatch) => swatch.classList.remove("selected"));
        selectedSwatch.classList.add("selected");

        if (wmeCareCheckbox) {
            wmeCareCheckbox.checked = false;
        }

         // Hide all warranty options initially
         warrantyOptions.forEach(option => option.classList.add("visually-hidden"));

         // Show only the warranty options related to the selected variant
         warrantyOptions.forEach(option => {
             if (option.getAttribute("data-base-variant-id") === variantId) {
                 option.classList.remove("visually-hidden");
             }
         });
 
         // Uncheck all warranty radio buttons
         warrantyRadios.forEach(radio => {
             radio.checked = false;
         });
    };

    swatchItems.forEach((swatch) => {
        swatch.addEventListener("click", () => {
            handleVariantSelection(swatch);
        });
    });

}

function rating_stars_fill(){
    const starFilled = document.querySelector('.star-filled');
    if (starFilled) {
        const ratingValue = parseFloat(starFilled.dataset.rating); // Fetch from data attribute
        if (!isNaN(ratingValue)) {
        starFilled.style.width = (ratingValue * 20) + '%'; // Calculate width
        } 
    }
}